<!-- eslint-disable vue/first-attribute-linebreak -->
<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <ul id="bmTab" class="nav nav-tabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button id="tab1-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab1" type="button" role="tab"
              aria-controls="tab1" aria-selected="true" @click="onClickTab('1')">
              {{ $t("apps.ghistoryall") }}
            </button>
          </li>

          <li class="nav-item" role="presentation">
            <button id="tab2-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2" type="button" role="tab"
              aria-controls="tab2" aria-selected="false" @click="onClickTab('2')">
              {{ $t("apps.gticketchain") }}
            </button>
          </li>
        </ul>

        <div id="bmTabContent" class="tab-content">
          <div id="tab1" class="tab-pane fade" role="tabpanel" aria-labelledby="tab1-tab">
            <div class="card mt-2">
              <div class="card-header mb-0">
                <h5>{{ $t("apps.ghistoryall") }}</h5>
              </div>
              <div class="card-body pt-0">
                <div class="row">

                 <div class="col-lg-3 mt-2">
                    <label class="form-label ms-0">{{ $t("content.shop_name") }}</label>
                    <select v-model="shop_search" class="form-select"  :disabled="shopList.length === 0">
                      <option value="" selected>{{ $t('content.optall') }}</option>
                      <option v-for="(item, index) in shopList" :value="item.uid" :key="index">
                        {{ item.nameTh }}
                      </option>
                    </select>
                  </div>  

                  <div class="col-lg-4 mt-2">
                    <label class="form-label ms-0">{{ $t("content.names") }}</label>
                    <div class="input-group">
                      <input v-model="cusName_search" type="text" class="form-control" aria-describedby="searchName"
                        readonly />
                      <button class="btn btn-primary" type="button" @click="openDialogCus">
                        <i class="material-icons material-symbols-outlined">search</i>
                      </button>
                      <button id="searchNameCus" class="btn btn-primary" type="button" data-bs-toggle="modal"
                        data-bs-target="#searchNameModal" v-show="false">
                      </button>
                    </div>
                  </div>

                  <div class="col-lg-2 mt-2">
                    <label class="form-label ms-0">{{ $t("content.masset") }}</label>
                    <select v-model="maincat_search" class="form-select">
                        <option value="">{{ $t("content.optall") }}</option>
                        <option v-for="(item, index) in listprint" :value="item.uid" :key="index">
                          {{ item.name }}
                        </option>
                    </select>
                  </div>

                  <div v-if="tx_search.length !== tx_type.length && filterTx()" class="col-lg-3 mt-2">
                    <label class="form-label ms-0">{{ $t("content.amnbiz") }}</label>
                    <MultiSelect v-model="type_search" :options="tx_mitype" optionLabel="name" filter placeholder=""
                      :maxSelectedLabels="3" variant="filled" fluid />
                  </div>

                  <div v-else class="col-lg-3 mt-2">
                    <label class="form-label ms-0">{{ $t("content.amnbiz") }}</label>
                    <MultiSelect v-model="type_search" :options="tx_nomitype" optionLabel="name" filter placeholder=""
                      :maxSelectedLabels="5" variant="filled" fluid />
                  </div>



                  <div class="col-lg-3 mt-0">
                    <fieldset>
                      <div class="item">
                        <span class="form-label m-0">{{ $t("content.status") }}</span>
                        <div class="d-inline-block mx-4">
                          <material-checkbox id="activewc" v-model="active_search" :checked="active_search"
                            name="autoSelect">{{ $t("content.activewc") }}
                          </material-checkbox>

                        </div>
                        <MultiSelect v-model="search_status" :options="status_type" optionLabel="name" filter
                          placeholder="" :maxSelectedLabels="4" variant="filled" fluid />
                      </div>
                    </fieldset>
                  </div>

                  <div class="col-lg-3 mt-3">
                    <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                    <material-input type="text" v-model="tk_search" />
                  </div>

                  <div class="col-lg-3 mt-3">
                    <label class="form-label ms-0">{{ $t("content.stockno") }}</label>
                    <material-input type="text" v-model="stockno_search" />
                  </div>

                  <div class="col-lg-3 mt-3">
                    <label class="form-label ms-0">Serial Number</label>
                    <material-input type="text" v-model="serial_search" />
                  </div>
                </div>

                <div class="row mt-4">
                  <div class="col-3 d-flex justify-content-between align-items-center"></div>
                  <div class="col-9 d-flex justify-content-end align-items-center">
                    <div class="me-3">
                      <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                        @click="loadDataHistoryApi">
                        <i class="material-icons material-symbols-outlined">search</i>
                        {{ search }}
                      </material-button>
                    </div>
                    <div class="me-3">
                      <material-button id="cardSearch" color="danger" class="float-lg-start float-sm-end mb-3"
                        @click="cancelBtn">
                        <i class="material-icons material-symbols-outlined">close</i>
                        {{ cancel }}
                      </material-button>
                    </div>
                  </div>
                </div>
                <pre></pre>
                <hr>
                <pre></pre>
                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.dant") }}</th>
                          <th>{{ $t("content.names") }}</th>
                          <th>{{ $t("content.amnticketold") }}</th>
                          <th>{{ $t("content.ticketno") }}</th>
                          <th>{{ $t("content.stockno") }}</th>
                          <th>{{ $t("content.migraref") }}</th>
                          <th>{{ $t("content.amnbiz") }}</th>
                          <th>{{ $t("content.masset") }}</th>
                          <th>{{ $t("content.allweight") }}</th>
                          <th>{{ $t("content.allqty") }}</th>
                          <th>{{ $t("content.amnpawnvalall") }}</th>
                          <th>{{ $t("content.amnreceiveprofit") }}</th>
                          <th>
                            {{ $t("content.actpawn3") }} /
                            {{ $t("content.actpawn4") }}
                          </th>
                          <th>{{ $t("content.gpay") }}</th>
                          <th>{{ $t("content.amnchannel") }}</th>
                          <th>{{ $t("content.assessor") }}</th>
                          <th>{{ $t("content.status") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in listhistory" :key="index"
                          :class="row.status !== 'TERMINATE' ? '' : 'bg-working'">
                          <td class="text-sm font-weight-normal">{{ formatNumberString((currentPage - 1) * perPage +
                            index + 1) }}</td>
                          <td class="text-sm font-weight-normal">{{ format_datetime(row.createDate) }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.changeName">
                              {{ row.cusName }}
                            </span>
                            <span v-else>
                              {{ row.tkCusName }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.prevRefNumber }}</td>
                          <td class="text-sm font-weight-normal">{{ row.refNumber }}</td>
                          <td class="text-sm font-weight-normal">{{ row.stockNumber }}</td>
                          <td class="text-sm font-weight-normal text-center">{{ row.migrateRefNumber }}</td>
                          <td class="text-sm font-weight-normal" :style="row.outage ? 'color:red' : ''">
                            <span v-if="row.represent">
                              <span v-if="row.migration">
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                  {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},ทำแทน,{{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                </span>
                                <span v-else>
                                   {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},ทำแทน{{checkOutage(',',row.outage)}})
                                </span>
                              </span>
                              <span v-else>
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                   {{ checkTransaction(row.type) }} (ทำแทน,{{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                </span>
                                <span v-else>
                                  {{ checkTransaction(row.type) }} (ทำแทน{{checkOutage(',',row.outage)}})
                                </span>
                              </span>
                            </span>
                            <span v-else-if="row.shopRepresent">
                              <span v-if="row.migration">
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                   {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }}{{checkShopRepresent(',',row)}})
                                </span>
                                <span v-else>
                                   {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }}{{checkShopRepresent(',',row)}})
                                </span>
                              </span>
                              <span v-else>
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                   {{ checkTransaction(row.type) }} {{checkShopRepresent('-',row)}}
                                </span>
                                <span v-else>
                                   {{ checkTransaction(row.type) }} {{checkShopRepresent('-',row)}}
                                </span>
                              </span>
                            </span>
                            <span v-else-if="row.changeName">
                              <span v-if="row.migration">
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                    {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType)
                                }},เปลี่ยนชื่อ,{{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                </span>
                                <span v-else>
                                    {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType)
                                }},เปลี่ยนชื่อ{{checkOutage(',',row.outage)}})
                                </span>
                              </span>
                              <span v-else>
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                  {{ checkTransaction(row.type) }} (เปลี่ยนชื่อ,{{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                </span>
                                <span v-else>
                                   {{ checkTransaction(row.type) }} (เปลี่ยนชื่อ{{checkOutage(',',row.outage)}})
                                </span>
                              </span>
                            </span>
                            <span v-else>
                              <span v-if="row.migration">
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                   {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},{{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                </span>
                                <span v-else>
                                    {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }}{{checkOutage(',',row.outage)}})
                                </span>
                              </span>
                              <span v-else>
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                   {{ checkTransaction(row.type) }} ({{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                </span>
                                <span v-else>
                                    {{ checkTransaction(row.type) }} {{checkOutage('-',row.outage)}}
                                </span>
                              </span>
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.catName }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.weight) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.quantity) }}</td>
                          <td class="text-sm font-weight-normal">
                            {{ formatNumberDecimalString(row.pawnValue) }}
                          </td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.roundInterest) }}
                          </td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.diffValue) }}</td>
                          <td class="text-sm font-weight-normal">
                            <span
                              v-if="row.type === 'DEC_PRINCIPLE' || row.type === 'INC_PRINCIPLE' || row.type === 'REDEEM'">
                              <span v-if="row.payOrReceive === row.roundInterest" style="color:blue">
                                {{ formatNumberDecimalString(row.payOrReceive) }}
                              </span>
                              <span v-else>
                                <span v-if="row.totalPay !== 0" style="color:red">
                                  {{ formatNumberDecimalString(row.payOrReceive) }}
                                </span>
                                <span v-else-if="row.totalReceive !== 0" style="color:green">
                                  {{ formatNumberDecimalString(row.payOrReceive) }}
                                </span>
                                <span v-else>
                                  {{ formatNumberDecimalString(row.payOrReceive) }}
                                </span>
                              </span>
                            </span>
                            <span v-else-if="row.type === 'INTEREST'">
                              <span v-if="row.payOrReceive !== row.roundInterest" style="color:blue">
                                {{ formatNumberDecimalString(row.payOrReceive) }}
                              </span>
                              <span v-else>
                                <span v-if="row.totalPay !== 0" style="color:red">
                                  {{ formatNumberDecimalString(row.payOrReceive) }}
                                </span>
                                <span v-else-if="row.totalReceive !== 0" style="color:green">
                                  {{ formatNumberDecimalString(row.payOrReceive) }}
                                </span>
                                <span v-else>
                                  {{ formatNumberDecimalString(row.payOrReceive) }}
                                </span>
                              </span>
                            </span>
                            <span v-else>
                              <span v-if="row.totalPay !== 0" style="color:red">
                                {{ formatNumberDecimalString(row.payOrReceive) }}
                              </span>
                              <span v-else-if="row.totalReceive !== 0" style="color:green">
                                {{ formatNumberDecimalString(row.payOrReceive) }}
                              </span>
                              <span v-else>
                                {{ formatNumberDecimalString(row.payOrReceive) }}
                              </span>
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.channel === 'SHOP'">
                              {{ $t("content.gchshop") }}
                            </span>
                            <span v-else>
                              LINE OA
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.managerName }}</td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ checkProcess(row.status) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button color="info" variant="outline" class="rounded-circle"
                              :title="t('buttons.seed')" @click="openDetail(row,'')">
                              <i class="material-icons material-symbols-outlined">visibility</i>
                            </material-button>
                            <material-button color="info" variant="outline" class="rounded-circle" v-show="false"
                              data-bs-toggle="modal" data-bs-target="#lookupModal" id="detailModal">
                            </material-button>
                            <material-button color="warning" variant="outline" class="rounded-circle" :title="chain"
                              @click="openListChain(row)">
                              <i class="material-icons material-symbols-outlined">arrow_forward</i>
                            </material-button>
                          </td>
                        </tr>
                        <tr v-if="listhistory.length === 0">
                          <td colspan="20" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr class="group-sub-header">
                          <td class="text-lg font-weight-bold text-end text-center" colspan="9">
                            <span v-if="listhistory.length > 0">
                              <b>{{ $t("content.gtotal") }}</b>
                            </span>
                          </td>
                          <td class="text-lg font-weight-bold">
                            <span v-if="listhistory.length > 0">
                              <b>{{ formatNumberDecimalString(totalWeight) }}</b>
                            </span>
                          </td>
                          <td class="text-lg font-weight-bold">
                            <span v-if="listhistory.length > 0">
                              <b>{{ formatNumberString(totalQuantity) }}</b>
                            </span>
                          </td>

                          <td class="text-lg font-weight-bold">
                            <span v-if="listhistory.length > 0">
                              <b>{{ formatNumberDecimalString(totalPawnValue) }}</b>
                            </span>
                          </td>
                          <td class="text-lg font-weight-bold">
                            <span v-if="listhistory.length > 0">
                              <b>{{ formatNumberDecimalString(totalInterest) }}</b>
                            </span>
                          </td>
                          <td class="text-lg font-weight-bold" colspan="5"></td>
                          <td style="text-align: right">Total Rows : {{ totalRows_s }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listhistory.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPage" :total-items="totalRows" :items-per-page="perPage"
                          @click="onClickHandler" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div id="tab2" class="tab-pane fade" role="tabpanel" aria-labelledby="tab2-tab">
            <div class="card mt-2">
              <div class="card-header mb-0">
                <div class="d-flex justify-content-between align-items-center">
                  <h5 style="display: inline-block; width: auto">
                    {{ $t("apps.gticketchain") }}
                  </h5>
                </div>
              </div>
              <div class="card-body pt-0">
                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.dant") }}</th>
                          <th>{{ $t("content.names") }}</th>
                          <th>{{ $t("content.trans") }}</th>
                          <th>{{ $t("content.ticketno") }}</th>
                          <th>{{ $t("content.allweight") }}</th>
                          <th>{{ $t("content.allqty") }}</th>
                          <th>{{ $t("content.allprice") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in listticketchain" :key="index">
                          <td class="text-sm font-weight-normal">{{ formatNumberString((currentPageT - 1) * perPageT +
                            index + 1) }}</td>
                          <td class="text-sm font-weight-normal">{{ format_datetime(row.createDate) }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.changeName">
                              {{ row.customerName }}
                            </span>
                            <span v-else>
                              {{ row.tkCustomerName }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.represent">
                              <span v-if="row.migration">
                                {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},ทำแทน)
                              </span>
                              <span v-else>
                                {{ checkTransaction(row.type) }} (ทำแทน)
                              </span>
                            </span>
                            <span v-else-if="row.shopRepresent">
                              <span v-if="row.migration">
                                {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},ออนไลน์)
                              </span>
                              <span v-else>
                                {{ checkTransaction(row.type) }} (ออนไลน์)
                              </span>
                            </span>
                            <span v-else-if="row.changeName">
                              <span v-if="row.migration">
                                {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType)
                                }},เปลี่ยนชื่อ)
                              </span>
                              <span v-else>
                                {{ checkTransaction(row.type) }} (เปลี่ยนชื่อ)
                              </span>
                            </span>
                            <span v-else>
                              <span v-if="row.migration">
                                {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }})
                              </span>
                              <span v-else>
                                {{ checkTransaction(row.type) }}
                              </span>
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.refNumber }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.weight) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.quantity) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.newPawnValue) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button color="info" variant="outline" class="rounded-circle"
                              :title="t('buttons.seed')" @click="openDetail(row,shop_chain)">
                              <i class="material-icons material-symbols-outlined">visibility</i>
                            </material-button>
                            <material-button color="info" variant="outline" class="rounded-circle" v-show="false"
                              data-bs-toggle="modal" data-bs-target="#lookupModal" id="detailModal">
                            </material-button>
                          </td>
                        </tr>
                        <tr v-if="listticketchain.length === 0">
                          <td colspan="10" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="10" style="text-align: right">Total Rows : {{ totalRows_sT }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listticketchain.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPageT" :total-items="totalRowsT"
                          :items-per-page="perPageT" @click="onClickHandlerT" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>


          <!-- Search Customer Dialog -->
          <div id="searchNameModal" class="modal fade" tabindex="-1" aria-labelledby="searchNameModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">{{ $t("content.cnamelist") }}</h4>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeModal">
                    <i class="material-icons material-symbols-outlined">close</i>
                  </button>
                </div>

                <div class="modal-body">
                  <div class="preview-table">
                    <section class="panel">
                      <table class="table table-striped table-responsive">
                        <thead>
                          <tr>
                            <!-- <th style="width: 100px">{{ $t("content.ccode") }}</th> -->
                            <th>#</th>
                            <th>{{ $t("content.cnameth") }}</th>
                            <th>{{ $t("content.cnameen") }}</th>
                            <th>{{ $t("content.docno") }}</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="row-search">
                            <td></td>
                            <td>
                              <material-input v-model="nameThC" type="text" :label="t('content.cnameth')" />
                            </td>
                            <td>
                              <material-input v-model="nameEnC" type="text" :label="t('content.cnameen')" />
                            </td>
                            <td>
                              <material-input v-model="docNumberC" type="text" :label="t('content.docno')" />
                            </td>
                            <td>
                              <material-button color="primary" variant="contain" class="rounded-circle ms-1"
                                data-bs-toggle="tooltip" data-bs-placement="top" :title="btnSearch"
                                :disabled="nameThC.length < 2 && nameEnC.length < 2 && docNumberC.length < 5"
                                @click="loadCustomerAfListApi">
                                <i class="material-icons material-symbols-outlined">search</i>
                              </material-button>
                            </td>
                          </tr>
                          <tr v-for="(row, index) in customerlist" :key="index" @click="selectCusAf(row)">
                            <td>{{ formatNumberString((currentPageC - 1) * perPageC + index + 1) }}</td>
                            <td>{{ row.nameTh }}</td>
                            <td>{{ row.nameEn }}</td>
                            <td colspan="2">{{ row.docNumber }}</td>
                          </tr>
                          <tr v-if="customerlist.length === 0">
                            <td colspan="5" class="text-sm font-weight-normal">
                              <p style="text-align: center">No Record Found</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </section>
                  </div>
                </div>

                <div class="modal-footer">
                  <pre></pre>
                  <div style="display: flex; justify-content: flex-end">
                    <ul v-show="customerlist.length > 0" class="pagination justify-content-end">
                      <div class="project-container">
                        <div class="example-one">
                          <vue-awesome-paginate v-model="currentPageC" :total-items="totalRowsC"
                            :items-per-page="perPageC" @click="onClickHandlerC" />
                        </div>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- Detail Modal -->
          <div id="lookupModal" class="modal fade" tabindex="-1" aria-labelledby="lookupModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-centered" style="max-width:1240px;">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">{{ $t("content.detail") }}</h4>
                  <div style="display: flex; justify-content: flex-end">
                    <div>
                      <div class="d-inline-block mx-4">
                      </div>
                    </div>
                    <div>
                      <div class="d-inline-block mx-4">
                      </div>
                    </div>
                    <div>
                      <div class="d-inline-block mx-4">
                        <material-checkbox id="infocus" v-model="fcusdt" :checked="fcusdt">
                          {{ $t("content.infofcus") }}
                        </material-checkbox>
                      </div>
                    </div>
                  </div>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <i class="material-icons material-symbols-outlined">close</i>
                  </button>
                </div>

                <div class="modal-body">
                  <div class="row">
                    <div class="col-lg-6 mt-2">
                      <div id="lookupImages" class="carousel slide" data-bs-touch="false" data-bs-interval="false"
                        style="max-width: 520px">
                        <div class="carousel-indicators" id="demo1">
                        </div>
                        <div class="carousel-inner">
                          <ul className="list-unstyled">
                            <li v-for="(item, index) in images.length" :key="index">
                              <span v-if="index === 0">
                                <div class="carousel-item active">
                                  <vue-image-zoomer :regular="images[index].src" img-class="img-fluid"
                                    class="d-block w-100" :zoom-amount="3" :click-zoom="true" close-pos="top-right"
                                    message-pos="top" />
                                </div>
                              </span>
                              <span v-else>
                                <div class="carousel-item">
                                  <vue-image-zoomer :regular="images[index].src" img-class="img-fluid"
                                    class="d-block w-100" :zoom-amount="3" :click-zoom="true" close-pos="top-right"
                                    message-pos="top" />
                                </div>
                              </span>
                            </li>
                          </ul>
                        </div>
                        <button class="carousel-control-prev" type="button" data-bs-target="#lookupImages"
                          data-bs-slide="prev">
                          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Previous</span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#lookupImages"
                          data-bs-slide="next">
                          <span class="carousel-control-next-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Next</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-lg-6 mt-2">
                      <div v-if="workcaseDetail !== null" style="overflow-x:auto;">
                        <div>
                          <table class="table table-sm table-borderless">
                            <tbody>
                              <tr>
                                <td class="fs-14 text-bold">{{ $t("content.ticketno") }} :
                                  <span v-if="workcaseDetail.tkRefNumber !== ''">
                                    {{ workcaseDetail.tkRefNumber }} &nbsp;
                                    <span @click='copyBtn()' style="cursor: pointer">
                                      <i class="inline-icon material-icons">content_copy</i>
                                    </span>
                                  </span>
                                  <span v-else>-</span>
                                </td>
                                <td class="fs-14 text-bold">{{ $t("content.stkeeptk") }} :
                                  <span v-if="workcaseDetail.deposit" style="color:green;">
                                    {{ $t("content.stdeposittk") }} ({{ dep_ref }})
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td class="fs-14 text-bold">{{ $t("content.trans") }} :
                                  {{ checkTransaction(workcaseDetail.transactionType) }}
                                </td>
                                <td class="fs-14 text-bold">{{ $t("content.statusticket") }} :
                                  <span v-if="workcaseDetail.status === 'FINISH'" style="color:green;">
                                    {{ tk_status }}
                                  </span>
                                  <span v-else-if="workcaseDetail.status === 'FREEZE' || workcaseDetail.status === 'TERMINATE'
                                    || workcaseDetail.status === 'BREAKING'" style="color:red;">
                                    <span v-if="workcaseDetail.status === 'BREAKING'">
                                      {{ tk_status }} ({{ format_date(workcaseDetail.breakingDate) }} : {{
                                        workcaseDetail.lotNumber }})
                                    </span>
                                    <span v-else>
                                      {{ tk_status }}
                                    </span>
                                  </span>
                                  <span v-else>
                                    {{ tk_status }}
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="workcaseDetail.postponeCount === 0">
                                <td class="fs-14 text-bold"> {{ $t("content.lasttrf") }} : {{
                                  format_datetime(workcaseDetail.workItems[0].startTime) }}</td>
                                <td class="fs-14 text-bold">
                                  {{ $t("content.amnduedate") }} :
                                  <span style="color:red;">
                                    {{ format_date(workcaseDetail.dueDate) }}
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="workcaseDetail.postponeCount !== 0">
                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.lasttrf") }} : {{
                                  format_datetime(workcaseDetail.workItems[0].startTime) }}</td>
                              </tr>
                              <tr v-if="workcaseDetail.postponeCount !== 0">
                                <td class="fs-14 text-bold" colspan="2">
                                  {{ $t("content.amnduedate") }} :
                                  <span style="color:red;">
                                    {{ format_date(workcaseDetail.dueDate) }} (ขอเลื่อนเป็นวันที่ {{
                                      format_date(workcaseDetail.postponeDate) }})
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="workcaseDetail.postponeCount !== 0">
                                <td class="fs-14 text-bold" colspan="2">
                                  {{ $t("content.deferpast") }} :
                                  <span @click='NewTab()' style="text-decoration: underline;color:red; cursor: pointer">
                                    {{ workcaseDetail.postponeCount }}
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td class="fs-14 text-bold">
                                  {{ $t("content.monthlyprofn") }} : {{
                                    formatNumberDecimalString(workcaseDetail.interestPerMonth) }}
                                  <span style="color:red;">
                                    ({{ format_date(new Date()) }})
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">
                                  {{ $t("content.currentprof") }} :
                                  <span style="color:red;">
                                    {{ formatNumberDecimalString(int_cal) }}
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold">
                                  {{ $t("content.prointerestn") }} :
                                  <span
                                    v-if="workcaseDetail.interestPromotion === null || workcaseDetail.interestPromotion === 0">
                                    -
                                  </span>
                                  <span style="color:blue;" v-else>
                                    {{ formatNumberDecimalString(workcaseDetail.interestPromotion) }}
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">
                                  {{ $t("content.periodpromotion") }} :
                                  <span v-if="workcaseDetail.promotionDuration === 0">
                                    -
                                  </span>
                                  <span style="color:blue;" v-else>
                                    {{ workcaseDetail.promotionDuration }} เดือน
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold">{{ $t("content.periodpawnn") }} :
                                  <span style="color:blue;">
                                    {{ int_period }} เดือน
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">{{ $t("content.amnbookno") }}
                                  <span style="color:blue;">
                                    {{ workcaseDetail.tkVolNo }}
                                  </span>
                                  &nbsp;{{ $t("content.amnno") }}
                                  <span style="color:blue;">
                                    {{ workcaseDetail.tkNo }}
                                  </span>
                                </td>
                              </tr>
                              <tr v-else>
                                <td class="fs-14 text-bold" colspan="2">{{ $t("content.periodpawnn") }} :
                                  <span style="color:blue;">
                                    {{ int_period }} เดือน
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold">{{ $t("content.amnqtypiece") }} :
                                  {{ formatNumberString(workcaseDetail.ticket.totalQuantity) }}
                                </td>
                                <td class="fs-14 text-bold">{{ $t("content.allweight") }} :
                                  {{ formatNumberDecimalString(workcaseDetail.ticket.totalWeight) }}
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold">{{ $t("content.pawnvalpv") }} :
                                  <span v-if="workcaseDetail.transactionType === 'PAWN'">
                                    {{ formatNumberDecimalString(0) }}
                                  </span>
                                  <span v-else>
                                    {{ formatNumberDecimalString(workcaseDetail.pawnValue) }}
                                    <span style="color:red;">
                                      ({{format_date(transdate_prv) }})
                                    </span>
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">{{ $t("content.actpawn3") }}/{{ $t("content.actpawn4") }}
                                  :
                                  {{ formatNumberDecimalString(workcaseDetail.diffValue) }}
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold">{{ $t("content.amnanalysval") }} :
                                  {{ formatNumberDecimalString(workcaseDetail.newPawnValue) }}
                                </td>
                                <td class="fs-14 text-bold">{{ $t("content.amnmaxvalall") }} :
                                  {{ formatNumberDecimalString(workcaseDetail.ticket.totalFullValue) }}
                                </td>
                              </tr>
                              <tr v-else>
                                <td class="fs-14 text-bold" colspan="2">{{ $t("content.amnanalysval") }} :
                                  {{ formatNumberDecimalString(workcaseDetail.newPawnValue) }}
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold">{{ $t("content.statusticketlost") }} :
                                  <span v-if="workcaseDetail.lostCount === 0" style="color:green;"> ไม่มี
                                  </span>
                                  <span v-else style="color:red;">
                                    มี ({{ workcaseDetail.lostCount }})
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">{{ $t("content.refnolost") }} :
                                  <span v-if="workcaseDetail.lostCount === 0" style="color:green;"> -
                                  </span>
                                  <span v-else style="color:red;">
                                    {{ workcaseDetail.lostRefNumber }}
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="workcaseDetail.represent || workcaseDetail.shopRepresent && !fcusdt">
                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.represent") }} :
                                  <span style="color:red;">
                                    {{workcaseDetail.customerInfo.name}}
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="workcaseDetail.changeName && !fcusdt">
                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.changeName") }} ({{ bf_changename }}) :
                                  <span style="color:red;">
                                    {{ af_changename }}
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.transoutage") }} :
                                  <span v-if="workcaseDetail.outage" style="color:red">
                                    {{ $t("content.yes") }}
                                  </span>
                                  <span v-else style="color:green">
                                    {{ $t("content.no") }}
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.amnlocationasset") }} :
                                  <span v-if="workcaseDetail.ticket.locationName !== null">
                                    {{ workcaseDetail.ticket.locationName }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>

                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.stockno") }} :
                                  <span v-if="workcaseDetail.ticket.stockNumber !== null">
                                    {{ workcaseDetail.ticket.stockNumber }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>

                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.migraref") }} :
                                  <span v-if="workcaseDetail.migrateRefNumber !== null">
                                    {{ workcaseDetail.migrateRefNumber }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>

                                </td>
                              </tr>
                            </tbody>
                          </table>

                          <span v-if="!fcusdt">
                            <span v-if="listinfo.length !== 0">
                              <table class="table table-sm table-borderless">
                                <tbody>
                                  <tr>
                                    <td class="fs-14 text-bold">
                                      <span style="text-decoration:underline;">
                                        {{ $t("content.amnassetdetail") }}
                                      </span>
                                    </td>
                                  </tr>

                                  <tr v-for="(row, index) in listinfo" :key="index">
                                    <td class="fs-14 text-bold">
                                      {{ formatNumberString(index + 1) }}. {{ row.remark }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </span>
                            <span v-else>
                              <tr>
                                <td class="fs-14 text-bold">
                                  <span style="text-decoration:underline;">
                                    {{ $t("content.amnassetdetail") }}
                                  </span>
                                  : -
                                </td>
                              </tr>
                            </span>
                          </span>
                          <span v-else>
                            <table class="table table-sm table-borderless">
                              <tbody>
                                <tr>
                                  <td class="fs-14 text-bold">
                                    <span style="text-decoration:underline;">
                                      {{ $t("content.amngrandtotal") }}
                                    </span> :
                                    {{ formatNumberDecimalString(workcaseDetail.newPawnValue) }} + {{
                                      formatNumberDecimalString(int_cal) }} =
                                    <span style="color:blue;">
                                      {{ formatNumberDecimalString(Number(workcaseDetail.newPawnValue) +
                                        Number(int_cal))
                                      }}
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </span>



                        </div>
                      </div>
                    </div>
                  </div>
                  <hr v-if="paymentE !== ''" />
                  <div class="col-12 mt-2" v-if="paymentE !== ''">
                    <div class="fs-14 text-bold">
                      <span style="text-decoration:underline;">
                        {{ $t("content.amnfinanceinfo") }}
                      </span>
                    </div>
                    <pre></pre>
                    <div class="row">
                      <div class="table-responsive">
                        <table class="table table-flush">
                          <thead class="thead-light">
                            <tr>
                              <th>#</th>
                              <th>{{ $t("content.ticketno") }}</th>
                              <th>{{ $t("content.amnbiz") }}</th>
                              <th colspan="5" class="align-top text-center" style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.amnincome") }}
                                </span>
                              </th>
                              <th colspan="4" class="align-top text-center" style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.amnoutcome") }}
                                </span>
                              </th>
                              <th colspan="4" class="align-top text-center" style="background-color:#CFEBFD;">
                                <span style="color:black;">
                                  {{ $t("content.fee") }}
                                </span>
                              </th>
                            </tr>
                            <tr>
                              <th colspan="3"></th>
                              <th class="align-top text-center" style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.amncash") }}
                                </span>
                              </th>
                              <th colspan="2" class="align-top text-center" style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.amnbanktransfer") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.amncreditcard") }}
                                </span>

                              </th>
                              <th class="align-top text-center" style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.amncheque") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.amncash") }}
                                </span>
                              </th>
                              <th colspan="3" class="align-top text-center" style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.amnbanktransfer") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#CFEBFD;">
                                <span style="color:black;">
                                  {{ $t("content.amncash") }}
                                </span>
                              </th>
                              <th colspan="2" class="align-top text-center" style="background-color:#CFEBFD;">
                                <span style="color:black;">
                                  {{ $t("content.amnbanktransfer") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#CFEBFD;">
                                <span style="color:black;">
                                  {{ $t("content.amncreditcard") }}
                                </span>
                              </th>
                            </tr>
                            <tr>
                              <th colspan="3"></th>
                              <th style="background-color:#dfffdd;"></th>
                              <th class="align-top text-center" style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.amnbankacc") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  QR Code
                                </span>
                              </th>
                              <th colspan="2" style="background-color:#dfffdd;"></th>
                              <th style="background-color:#fecac7;"></th>
                              <th class="align-top text-center" style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.amnbankacc") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.amntransfer_promt_mobile") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.amntransfer_promt_taxid") }}
                                </span>
                              </th>
                              <th style="background-color:#CFEBFD;"></th>
                              <th class="align-top text-center" style="background-color:#CFEBFD;">
                                <span style="color:black;">
                                  {{ $t("content.amnbankacc") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#CFEBFD;">
                                <span style="color:black;">
                                  QR Code
                                </span>
                              </th>
                              <th style="background-color:#CFEBFD;"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(row, index) in paymentE.workCases" :key="index">
                              <template v-if="row.ticket !== null">
                                <td class="text-sm font-weight-normal text-center">{{ formatNumberString(index + 1) }}
                                </td>
                                <td class="text-sm font-weight-normal text-center">{{ row.tkRefNumber }}</td>
                                <td class="text-sm font-weight-normal text-center">{{
                                  checkTransaction(row.transactionType) }}</td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[0].receive > 0" style="color:green;">
                                    {{ formatNumberDecimalString(payment_l[0].receive) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[1].receive > 0" style="color:green;">
                                    {{ formatNumberDecimalString(payment_l[1].receive) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[6].receive > 0" style="color:green;">
                                    {{ formatNumberDecimalString(payment_l[6].receive) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[2].receive > 0" style="color:green;">
                                    {{ formatNumberDecimalString(payment_l[2].receive) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[3].receive > 0" style="color:green;">
                                    {{ formatNumberDecimalString(payment_l[3].receive) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[0].pay > 0" style="color:red;">
                                    {{ formatNumberDecimalString(payment_l[0].pay) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[1].pay > 0" style="color:red;">
                                    {{ formatNumberDecimalString(payment_l[1].pay) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[4].pay > 0" style="color:red;">
                                    {{ formatNumberDecimalString(payment_l[4].pay) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[5].pay > 0" style="color:red;">
                                    {{ formatNumberDecimalString(payment_l[5].pay) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[0].fee > 0" style="color:blue;">
                                    {{ formatNumberDecimalString(payment_l[0].fee) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[1].fee > 0" style="color:blue;">
                                    {{ formatNumberDecimalString(payment_l[1].fee) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[6].fee > 0" style="color:blue;">
                                    {{ formatNumberDecimalString(payment_l[6].fee) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[2].fee > 0" style="color:blue;">
                                    {{ formatNumberDecimalString(payment_l[2].fee) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                              </template>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>



        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import ProgressSpinner from 'primevue/progressspinner';
import { reactive, ref, computed, onMounted, inject, onUpdated } from "vue";
import { useI18n } from "vue-i18n";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import ExampleFive from "@/examples/ExampleOne";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue"
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';
import MultiSelect from 'primevue/multiselect';

import axios from "axios";
import * as st from "@/config/setting.js";
import moment from 'moment'
import noImg from "@/assets/img/noimg.png"

import { useCustomerStore } from '@/stores/customer'
import { useWorkCaseStore } from '@/stores/workcase'
import { useInterestStore } from '@/stores/interest'
import { usePaymentGroupStore } from '@/stores/paymentgroup'
import { useDocumentStore } from '@/stores/document'
import { useShopStore } from '@/stores/shop'
import { useDepositStore } from '@/stores/deposit'
import { useCategoryStore } from '@/stores/category'



const storecus = useCustomerStore()
const storewc = useWorkCaseStore()
const storei = useInterestStore()
const storep = usePaymentGroupStore()
const storesh = useShopStore()
const storedepo = useDepositStore()
const stored = useDocumentStore()
const storec = useCategoryStore()


const { t } = useI18n();
const swal = inject("$swal");


const exportFile = reactive([
  {
    cl: "info",
    cs: "me-2",
    ic: "picture_as_pdf",
    nm: "pdf",
    ac: "",
  },
  {
    cl: "info",
    cs: "",
    ic: "table_rows",
    nm: "excel",
    ac: "",
  },
]);


const cancel = computed(() => t("buttons.canc"));
const chain = computed(() => t('buttons.seed') + t("apps.gticketchain"));
const search = computed(() => t("buttons.sear"));

const fmNumber = (val) => {
  return Intl.NumberFormat("en-US").format(val);
};

const format = (date) => {
  return moment(String(date)).local().format('DD/MM/YYYY HH:mm');
}

const textInputOptions = {
  format: 'dd/MM/yyyy HH:mm'
};


const tx_type = ref([
  { name: t("content.cintrate1"), code: 'NORMAL' },
  { name: t("content.transmig"), code: 'MIGRATION' },
]);

const tx_mitype = ref([
  { name: t("content.actpawn2"), code: 'INTEREST' },
  { name: t("content.actpawn3"), code: 'INC_PRINCIPLE' },
  { name: t("content.actpawn4"), code: 'DEC_PRINCIPLE' },
]);

const tx_nomitype = ref([
  { name: t("content.actpawn1"), code: 'PAWN' },
  { name: t("content.actpawn2"), code: 'INTEREST' },
  { name: t("content.actpawn3"), code: 'INC_PRINCIPLE' },
  { name: t("content.actpawn4"), code: 'DEC_PRINCIPLE' },
  { name: t("content.actpawn5"), code: 'REDEEM' },
]);

const status_type = ref([
  { name: t("content.status_finish"), code: 'FINISH' },
  { name: t("content.status_freeze"), code: 'FREEZE' },
  { name: t("content.status_termi"), code: 'TERMINATE' },
  { name: t("content.status_breaking"), code: 'BREAKING' },
]);

const channel_type = ref([
  { name: t("content.gchshop"), code: 'SHOP' },
  { name: 'LINE OA', code: 'LINE_LIFF' },
]);


const currentPage = ref(1);
const totalRows = ref(1);
const perPage = ref(30);
const totalRows_s = ref();

const currentPageT = ref(1);
const totalRowsT = ref(1);
const perPageT = ref(30);
const totalRows_sT = ref();

const currentPageC = ref(1);
const totalRowsC = ref(1);
const perPageC = ref(10);
const totalRows_sC = ref();

const nameThC = ref('')
const nameEnC = ref('')
const docNumberC = ref('')


const start_date = ref(new Date(new Date().setHours(0, 0, 0)));
const end_date = ref(new Date(new Date().setHours(23, 59, 59)));
const cusUid_search = ref('');
const cusName_search = ref('');
const tk_search = ref('');
const type_search = ref('');
const serial_search = ref('');
const search_status = ref('');
const tx_search = ref('');
const miref_search = ref('');
const stockno_search = ref('');
const active_search = ref(false);
const channel_search = ref('');


const totalQuantity = ref(0);
const totalPawnValue = ref(0);
const totalWeight = ref(0);
const totalInterest = ref(0);



const listprint = ref([]);
const listhistory = ref([]);
const listticketchain = ref([]);
const listinfo = ref([]);
const customerlist = ref([])
const info_cat = ref('');
const workcaseDetail = ref(null);
const chain_uid = ref('');
const tk_status = ref('');
const int_cal = ref(0);

const paymentE = ref('');
const time = ref(false);


const images = ref([])
const images_l = ref([])
const payment_l = ref([])
const loading = ref(false);
const int_period = ref('');
const fcusdt = ref(false);
const dep_ref = ref('');
const bf_changename = ref('');
const af_changename = ref('');
const transdate_prv = ref(null);


const shopList = ref([]);
const shop_search = ref('');
const shop_chain = ref('');
const maincat_search = ref('');



const onClickHandler = (page) => {
  updatePagination()
};


const onClickHandlerT = (page) => {
  updatePaginationT()
};

const onClickHandlerC = (page) => {
  updatePaginationC()
};


const loadDataList = async () => {
  if (localStorage.getItem("shoplist") !== null) {
    shopList.value = JSON.parse(localStorage.getItem("shoplist"));
  }
};

loadDataList();



function copyBtn() {
  navigator.clipboard.writeText(workcaseDetail.value.tkRefNumber);
}



function cancelBtn() {
  time.value = false;
  start_date.value = new Date(new Date().setHours(0, 0, 0));
  end_date.value = new Date(new Date().setHours(23, 59, 59));
  cusUid_search.value = '';
  cusName_search.value = '';
  tk_search.value = '';
  serial_search.value = '';
  currentPage.value = 1
  listhistory.value = []
  listticketchain.value = []
  totalRows_s.value = ''
  totalQuantity.value = 0;
  totalPawnValue.value = 0;
  totalWeight.value = 0
  totalInterest.value = 0
  miref_search.value = ''
  stockno_search.value = ''
  active_search.value = false
  type_search.value = tx_nomitype.value
  search_status.value = status_type.value
  tx_search.value = tx_type.value
  channel_search.value = channel_type.value
  shop_search.value = ''  
  maincat_search.value = ''


}

function filterTx() {
  let process = false
  if (tx_search.value.length > 0) {
    let name = tx_search.value.filter((c) => c.code.trim() === 'MIGRATION');
    if (name.length > 0) {
      process = true
    }
  }
  return process
}

const loadDataHistoryApi = async () => {
  // console.log("start_date  : " + moment(new Date(start_date.value)).format('YYYY-MM-DDThh:mm:00') + " end_date : " + moment(new Date(end_date.value)).local());

  currentPage.value = 1
  let data = "";
  let sd = ''
  let ed = ''

  let status = ''
  if (search_status.value.length !== status_type.value.length) {
    for (let i = 0; i < search_status.value.length; i++) {
      if (status === '') {
        status = search_status.value[i].code.trim()
      } else {
        status = status + ',' + search_status.value[i].code.trim()
      }
    }
  }


  let txFilter = ''

  if (tx_search.value.length !== tx_type.value.length) {
    for (let i = 0; i < tx_search.value.length; i++) {
      if (txFilter === '') {
        txFilter = tx_search.value[i].code.trim()
      } else {
        txFilter = txFilter + ',' + tx_search.value[i].code.trim()
      }
    }
  }

  let type = ''
  if (txFilter !== '') {
    if (txFilter.includes("MIGRATION")) {
      if (type_search.value.length !== tx_mitype.value.length) {
        for (let i = 0; i < type_search.value.length; i++) {
          if (type === '') {
            type = type_search.value[i].code.trim()
          } else {
            type = type + ',' + type_search.value[i].code.trim()
          }
        }
      }
    } else {
      if (txFilter.includes("NORMAL")) {
        if (type_search.value.length !== tx_nomitype.value.length) {
          for (let i = 0; i < type_search.value.length; i++) {
            if (type === '') {
              type = type_search.value[i].code.trim()
            } else {
              type = type + ',' + type_search.value[i].code.trim()
            }
          }
        }
      }
    }
  } else {
    if (type_search.value.length !== tx_nomitype.value.length) {
      for (let i = 0; i < type_search.value.length; i++) {
        if (type === '') {
          type = type_search.value[i].code.trim()
        } else {
          type = type + ',' + type_search.value[i].code.trim()
        }
      }
    }
  }

  let channel = ''
  if (channel_search.value.length !== channel_type.value.length) {
    for (let i = 0; i < channel_search.value.length; i++) {
      if (channel === '') {
        channel = channel_search.value[i].code.trim()
      } else {
        channel = channel + ',' + channel_search.value[i].code.trim()
      }
    }
  }


  if (time.value) {
    sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
    ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')
  }

  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    cusUid: cusUid_search.value,
    refNumber: tk_search.value,
    fromDate: sd,
    toDate: ed,
    type: type,
    serialNumber: serial_search.value,
    shopUid: shop_search.value,  
    status: status,
    txFilter: txFilter,
    groupUid:shopList.value[0].groupUid,
    migrateRefNumber: '',
    stockNumber: stockno_search.value.trim(),
    active: active_search.value,
    channel: channel,
    catUid:maincat_search.value
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storewc.workCaseHistoryFetch(payload);
  // console.log("loadHistory : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc !== "success") {
        listhistory.value = []
        totalRows.value = 0
        totalRows_s.value = ''
      } else {
        listhistory.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
        totalQuantity.value = response.data.data.ext.quantity;
        totalPawnValue.value = response.data.data.ext.pawnValue;
        totalWeight.value = response.data.data.ext.weight;
        totalInterest.value = response.data.data.ext.roundInterest;
      }
    }
  }

}


const loadDataPrintApi = async () => {
  // await new Promise((res) => setTimeout(res, 500));
  let data = "";
  data = {
    uid: "",
  };
  const payload = data;
  // const response = await store.dispatch("categorylistPrintFetch", payload);
  const response = await storec.categorylistPrintFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listprint.value = response.data.data;
        // console.log('Listdata : ' + JSON.stringify(listprint.value))
      }
    }
  }
};


const setValue = async () => {
  type_search.value = tx_nomitype.value
  search_status.value = status_type.value
  tx_search.value = tx_type.value
  channel_search.value = channel_type.value
  await loadDataPrintApi()
}

setValue()


async function getworkCaseInfo(id,shopUid) {
  let data = "";
  data = {
    uid: id,
    groupUid: shopList.value[0].groupUid,
    shopUid: shopUid,
  };
  const payload = data;
  // console.log("workCaseInfo p : " + JSON.stringify(payload));
  const response = await storewc.workCaseinfoAdminFetch(payload);
  // console.log("getworkCaseInfo : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseDetail.value = response.data.data
      }
    }
  }
}


async function getListChain(item) {
  shop_chain.value = item.shopUid
  let data = "";
  data = {
    index: currentPageT.value - 1,
    size: perPageT.value,
    uid: chain_uid.value,
    shopUid: shop_chain.value,
  };
  const payload = data;

  const response = await storewc.workCaseListChainFetch(payload);
  // console.log("getListChain : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listticketchain.value = response.data.data.list;
        totalRowsT.value = response.data.data.ext.total
        totalRows_sT.value = formatNumberString(totalRowsT.value)
      }
      onClickTab('2')
    }
  }
}

async function calIntInt() {
  // console.log('workcaseDetail : ' + JSON.stringify(workcaseDetail.value));
  let postponeDate = ''
  if (workcaseDetail.value.postponeCount != 0) {
    postponeDate = moment(workcaseDetail.value.postponeDate).format('YYYY-MM-DD')
  }
  let data = "";
  data = {
    pawnDate: moment(workcaseDetail.value.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    postponeDate: postponeDate,
    pawnValue: workcaseDetail.value.newPawnValue,
    promotionUid: workcaseDetail.value.promotionUid,
    interestUid: workcaseDetail.value.interestUid,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestCalculateFetch(payload);
  // console.log("calIntInt r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        int_cal.value = Number(res.overdueInterest) + Number(res.dueInterest)
      }
    }
  }
}


async function detailPayment(item, shopUid) {
  // console.log('detailPayment : ' + item);
  let data = "";
  data = {
    groupUid: shopList.value[0].groupUid,
    shopUid: shopUid,
    uid: item,
  };
  const payload = data;
  const response = await storep.paymentGroupInfoAdminFetch(payload);
  // console.log("detailPayment : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        paymentE.value = response.data.data
        filterPayType()
        // console.log('detailPayment : ' + JSON.stringify(paymentE.value));
      }
    }
  }
}

function filterCat(str) {
  let side = ''
  let name = listprint.value.filter((c) => c.uid === str);
  if (name.length > 0) {
    side = name[0].name
  }
  return side
}


function format_datetime(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY HH:mm')
  }
}

function format_date(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY')
  }
}

function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function checkProcess(str) {
  let side = ''
  if (str === 'FINISH') {
    side = 'เสร็จสิ้น'
  } else if (str === 'ACTIVE') {
    side = 'กำลังดำเนินการ'
  } else if (str === 'FREEZE') {
    side = 'อายัด'
  } else if (str === 'TERMINATE') {
    side = 'ยกเลิก'
  } else if (str === 'BREAKING') {
    side = 'ของหลุด'
  }
  return side
}

function checkTransaction(str) {
  // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
  let side = ''
  if (str === 'PAWN') {
    side = 'จำนำ'
  } else if (str === 'INTEREST') {
    side = 'ต่อดอกเบี้ย'
  } else if (str === 'REDEEM') {
    side = 'ไถ่ถอน'
  } else if (str === 'INC_PRINCIPLE') {
    side = 'เพิ่มต้น'
  } else if (str === 'DEC_PRINCIPLE') {
    side = 'ลดต้น'
  }
  return side
}


function containsOnlyNumbers(str){
  return /^\d+$/.test(str);
}

function checkOutage(str,val) { 
  let side = ''
  if (val) {
    if (str === ',') {
      side = str + t("content.outage")
    } else  if (str === '-') {
      side = '('+t("content.outage") + ')'
    }
    
  }
  return side
}

function checkShopRepresent(str,item) { 
  let side = ''
  if (item.outage === false) {
    if (str === ',') {
      side = str + t("content.gchonline")
    } else if (str === '-') {
      side = '(' + t("content.gchonline")
    }
  }

  
  if (containsOnlyNumbers(item.initRefNumber)) {
    if (side === '') {
      if (str === ',') {
          side = ','+t("content.translost")
        } else if (str === '-') {
          side = '('+t("content.translost")
        }
    } else {
      side = side + ','+t("content.translost")
    }
  }

  if (item.outage) {
      if (side === '') {
        if (str === ',') {
            side = str + t("content.outage")
          } else if (str === '-') {
            side = '(' + t("content.outage")
          }
      } else {
        side =  side + ','+t("content.outage")
      }
    }

  if (side !== '' && str === '-') {
    side = side + ')'
  }  

  return side
}



function filterPayType() {
  payment_l.value = []
  let pt = [{ name: 'CASH' },
  { name: 'BANK_TRANSFER' },
  { name: 'CREDIT_CARD' },
  { name: 'CHEQUE' },
  { name: 'PROMPT_PAY_MOBILE' },
  { name: 'PROMPT_PAY_TAX_ID' },
  { name: 'QR_CODE' },
  ]
  let lsum = []
  for (let i = 0; i < pt.length; i++) {
    lsum = filterSumPay(pt[i].name)
    if (lsum.length > 0) {
      payment_l.value.push({ name: pt[i].name, pay: lsum[0].pay, receive: lsum[0].receive, fee: lsum[0].fee })
    } else {
      payment_l.value.push({ name: pt[i].name, pay: 0, receive: 0, fee: 0 })
    }
  }
}

function filterSumPay(str) {
  let nump = 0, numr = 0, numf = 0
  let lp = paymentE.value.payments.filter((c) => c.type === str);
  if (lp.length > 0) {
    let pay = 0
    let receive = 0
    let fee = 0
    for (let i = 0; i < lp.length; i++) {
      pay = pay + lp[i].pay
      receive = receive + lp[i].receive
      fee = fee + lp[i].feeReceive
      // fee = fee + lp[i].fee
    }
    nump = pay
    numr = receive
    numf = fee
  }
  let lockL = []
  lockL.push({ pay: nump, receive: numr, fee: numf })
  // console.log('lockL : ' + JSON.stringify(lockL));
  return lockL
}




async function onClickTab(val) {
  if (val === '1') {
    await setfirstTab()
  } else if (val === '2') {
    await setsecondTab()
  }
}


async function setfirstTab() {
  if (document.getElementById("tab2-tab")) {
    document.getElementById("tab2-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2")) {
    document.getElementById("tab2").classList.remove('show', 'active')
  }

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.add('show', 'active')
  }
}


async function setsecondTab() {

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2-tab")) {
    document.getElementById("tab2-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab2")) {
    document.getElementById("tab2").classList.add('show', 'active')
  }
}

async function selectCusAf(item) {
  // console.log('selectCusAf : ' + JSON.stringify(item));
  cusUid_search.value = item.uid
  cusName_search.value = item.nameTh
  document.getElementById("closeModal").click();
}

async function loadCustomerAfListApi() {
  currentPageC.value = 1
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value

  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storecus.searchCustomerFetch(payload);
  // console.log("loadCustomerListApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list;
        customerlist.value = listd;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}

async function updatePagination() {
  listhistory.value = []
  let sd = ''
  let ed = ''

  let status = ''
  if (search_status.value.length !== status_type.value.length) {
    for (let i = 0; i < search_status.value.length; i++) {
      if (status === '') {
        status = search_status.value[i].code.trim()
      } else {
        status = status + ',' + search_status.value[i].code.trim()
      }
    }
  }


  let txFilter = ''

  if (tx_search.value.length !== tx_type.value.length) {
    for (let i = 0; i < tx_search.value.length; i++) {
      if (txFilter === '') {
        txFilter = tx_search.value[i].code.trim()
      } else {
        txFilter = txFilter + ',' + tx_search.value[i].code.trim()
      }
    }
  }

  let type = ''
  if (txFilter !== '') {
    if (txFilter.includes("MIGRATION")) {
      if (type_search.value.length !== tx_mitype.value.length) {
        for (let i = 0; i < type_search.value.length; i++) {
          if (type === '') {
            type = type_search.value[i].code.trim()
          } else {
            type = type + ',' + type_search.value[i].code.trim()
          }
        }
      }
    } else {
      if (txFilter.includes("NORMAL")) {
        if (type_search.value.length !== tx_nomitype.value.length) {
          for (let i = 0; i < type_search.value.length; i++) {
            if (type === '') {
              type = type_search.value[i].code.trim()
            } else {
              type = type + ',' + type_search.value[i].code.trim()
            }
          }
        }
      }
    }
  } else {
    if (type_search.value.length !== tx_nomitype.value.length) {
      for (let i = 0; i < type_search.value.length; i++) {
        if (type === '') {
          type = type_search.value[i].code.trim()
        } else {
          type = type + ',' + type_search.value[i].code.trim()
        }
      }
    }
  }

  let channel = ''
  if (channel_search.value.length !== channel_type.value.length) {
    for (let i = 0; i < channel_search.value.length; i++) {
      if (channel === '') {
        channel = channel_search.value[i].code.trim()
      } else {
        channel = channel + ',' + channel_search.value[i].code.trim()
      }
    }
  }


  if (time.value) {
    sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
    ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')
  }
  let data = "";
  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    cusUid: cusUid_search.value,
    refNumber: tk_search.value,
    fromDate: sd,
    toDate: ed,
    type: type,
    serialNumber: serial_search.value,
    shopUid: shop_search.value,
    status: status,
    txFilter: txFilter,
    groupUid:shopList.value[0].groupUid,
    migrateRefNumber: '',
    stockNumber: stockno_search.value.trim(),
    active: active_search.value,
    channel: channel,
    catUid:maincat_search.value
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storewc.workCaseHistoryFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc !== "success") {
        listhistory.value = []
        totalRows.value = 0
        totalRows_s.value = ''
      } else {
        listhistory.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
        totalQuantity.value = response.data.data.ext.quantity;
        totalPawnValue.value = response.data.data.ext.pawnValue;
        totalWeight.value = response.data.data.ext.weight;
        totalInterest.value = response.data.data.ext.roundInterest;
      }
    }
  }

}


async function updatePaginationT() {
  listticketchain.value = []
  let data = "";
  data = {
    index: currentPageT.value - 1,
    size: perPageT.value,
    uid: chain_uid.value,
  };
  const payload = data;

  const response = await storewc.workCaseListChainFetch(payload);
  // console.log("getworkCaseInfo : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listticketchain.value = response.data.data.list;
        totalRowsT.value = response.data.data.ext.total
        totalRows_sT.value = formatNumberString(totalRowsT.value)
      }
    }
  }

}



async function updatePaginationC() {
  customerlist.value = []
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value

  };
  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storecus.searchCustomerFetch(payload);
  // console.log("loadCashAccDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        customerlist.value = response.data.data.list;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}


function setGallery() {

  var x = "", i, y = "";

  for (i = 0; i < images.value.length; i++) {
    if (i == 0) {
      y = y + '<button type = "button" data-bs-target="#lookupImages" data-bs-slide-to="' + String(i) + '"' +
        ' class="active" aria-current="true" aria-label="Slide ' + Number(i + 1) + '"> </button >';
    } else {
      // console.log('itemImg zzz : ' + i + " " + JSON.stringify(images.value[i].src))
      y = y + '<button type = "button" data-bs-target="#lookupImages" data-bs-slide-to="' + String(i) + '"' +
        ' aria-label="Slide ' + Number(i + 1) + '"> </button >';
    }

  }
  document.getElementById("demo1").innerHTML = y;
}


async function openDetail(item, shopUid) {
  workcaseDetail.value = null
  images.value = []
  images_l.value = []
  listinfo.value = []
  info_cat.value = ''
  tk_status.value = ''
  int_cal.value = 0
  paymentE.value = ''
  int_period.value = ''
  fcusdt.value = false
  dep_ref.value = ''
  bf_changename.value = ''
  af_changename.value = ''
  transdate_prv.value = null

  if (shopUid === '') { 
    shopUid = item.shopUid
  }
  await getworkCaseInfo(item.uid,shopUid)
  if (workcaseDetail.value != null) {
    // console.log('workcaseDetail : ' + JSON.stringify(workcaseDetail.value));
    if (workcaseDetail.value.changeName) {
      af_changename.value = item.cusName
      await getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber,shopUid)
    }else { 
          if (workcaseDetail.value.transactionType !== 'PAWN') { 
              await getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber,shopUid)
          }
    }
        
    if (workcaseDetail.value.deposit) {
      await getDepositInfo(workcaseDetail.value.tkRefNumber,shopUid)
    }
    await detailPayment(workcaseDetail.value.paymentGroupUid,shopUid)

    images_l.value = workcaseDetail.value.ticket.images
    listinfo.value = workcaseDetail.value.ticket.collaterals

    if (workcaseDetail.value.transactionType !== 'REDEEM') {
      await calIntInt()
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ปกติ'
      } else if (workcaseDetail.value.status === 'FREEZE') {
        tk_status.value = 'อายัด'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      } else if (workcaseDetail.value.status === 'ACTIVE') {
        tk_status.value = 'กำลังดำเนินการ'
      } else if (workcaseDetail.value.status === 'BREAKING') {
        tk_status.value = 'ของหลุด'
      }

    } else {
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ไถ่ถอน'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      }
    }
    if (images_l.value.length > 0) {
      getTicketImage(shopUid)
    } else {
      let obj = {
        src: noImg,
        thumbnailImageSrc: noImg,
        alt: '',
        title: ''
      }
      images.value.push(obj)
      setGallery()
      document.getElementById("detailModal").click();

    }
  }
}

async function getTicketImage(shopUid) {
  images.value = []
  for (let i = 0; i < images_l.value.length; i++) {
    if (images_l.value[i].imageUid !== "0") {
      await getFileImg(images_l.value[i].imageUid, images_l.value[i].uid,shopUid)
    }
  }
  if (images.value.length > 0) {
    setGallery()
    document.getElementById("detailModal").click();
    loading.value = false
  } else {
    let obj = {
      src: noImg,
      thumbnailImageSrc: noImg,
      alt: '',
      title: ''
    }
    images.value.push(obj)
    setGallery()
    document.getElementById("detailModal").click();
    loading.value = false
  }
}

async function getFileImg(imageUid,uid,shopUid) {
  let data = "";
  data = {
    shopUid: shopUid,
    uid: imageUid,
  };
  const payload = data;
  // console.log('fi p : ' + JSON.stringify(payload));
  const response = await stored.imgAdminInfoFetch(payload);

  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // console.log('fi r : ' + JSON.stringify(response.data));
        const file = getFileFromBase64(response.data.data.data, response.data.data.name)
        const data = URL.createObjectURL(file);
        let obj = {
          src: data,
          thumbnailImageSrc: data,
          alt: '',
          title: file.type,
          uid: uid,
          imageUid: imageUid,
        }
        images.value.push(obj)
      }
    }
  }
}

async function openListChain(item) {
  chain_uid.value = item.uid
  currentPageT.value = 1
  listticketchain.value = []
  await getListChain(item)
}

async function openDialogCus() {
  nameThC.value = ''
  nameEnC.value = ''
  docNumberC.value = ''
  cusUid_search.value = ''
  cusName_search.value = ''
  customerlist.value = []
  document.getElementById("searchNameCus").click();
}

function getFileFromBase64(string64, fileName) {
  const trimmedString = string64.replace('dataimage/jpegbase64', '');
  // const trimmedString = string64;
  const imageContent = atob(trimmedString);
  const buffer = new ArrayBuffer(imageContent.length);
  const view = new Uint8Array(buffer);

  for (let n = 0; n < imageContent.length; n++) {
    view[n] = imageContent.charCodeAt(n);
  }
  var ext = fileName.split('.').pop();
  let type = '';
  if (ext === 'jpg') {
    type = 'image/jpeg'
  } else if (ext === 'png') {
    type = 'image/png'
  }
  const blob = new Blob([buffer], { type });
  return new File([blob], fileName, { lastModified: new Date().getTime(), type });
}


async function getworkCaseInfoPrv(prevRefNumber,shopUid) {
  let workcase_prv = null
  let data = "";
  data = {
    groupUid: shopList.value[0].groupUid,
    shopUid: shopUid,
    refNumber: prevRefNumber,
  };
  const payload = data;

  const response = await storewc.workCaseInfoByRefFetch(payload);
  //  console.log("workCaseInfoByRef : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcase_prv = response.data.data
        bf_changename.value = workcase_prv.tkCustomerInfo.name 
        transdate_prv.value = workcase_prv.workItems[0].startTime
      }
    }
  }
}


async function getDepositInfo(tkRef,shopUid) {
  let data = "";
  data = {
    index: 0,
    size: 1,
    groupUid: shopList.value[0].groupUid,
    shopUid: shopUid,
    cusUid: '',
    refNumber: '',
    tkRefNumber: tkRef.trim(),
    channel: '',
    txDate: 0,
  };
  const payload = data;
  // console.log("ld p : " + JSON.stringify(payload));
  const response = await storedepo.listDepositFetch(payload);
  // console.log("ld r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list
        dep_ref.value = listd[0].refNumber
      }
    }
  }
}



onMounted(() => {

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.add('show', 'active')
  }
});


</script>

<style lang="scss" scoped>
.inline-icon {
  display: inline-flex;
  vertical-align: top;
  font-size: 20px !important;
}

.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.grid-container {
  max-width: 990px;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.btnClose {
  border-color: transparent !important;
  background-color: white !important;
  vertical-align: baseline;

  i.material-icons {
    padding-top: 8px;
    color: gray-600;
  }
}

.grid-containerP {
  max-width: 990px;
  display: grid;
  grid-gap: 1px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}

.wrapper {
  position: relative;
}

.myLayer {
  position: absolute;
  /* becomes a layer */
  // left: 0;
  /* relative to its parent wrapper */
  top: -18px;
  right: -23px;
  /* relative to its parent wrapper */
  z-index: 2;
  font-size: 20px;
}

.fs-14 {
  font-size: 0.875rem;
}
</style>
